// extracted by mini-css-extract-plugin
export default {"authorize":"Autauthorize_authorize__Idzdo","svg":"Autauthorize_svg__QptQj"};